import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoFood = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Food</title>
    <rect x={3.66} y={16} width={24.67} height={4.383} rx={1.994} stroke="currentColor" strokeWidth={2} />
    <path
      d="m6.491 23.24-.611-3.056h20.13l-.986 3.288a2.532 2.532 0 0 1-2.425 1.804H8.974a2.532 2.532 0 0 1-2.483-2.035Z"
      stroke="currentColor"
      strokeWidth={2}
    />
    <rect x={10.351} y={10.674} width={2.837} height={2.128} rx={1.064} fill="currentColor" />
    <rect x={18.862} y={10.674} width={2.837} height={2.128} rx={1.064} fill="currentColor" />
    <rect x={14.606} y={9.255} width={2.837} height={2.128} rx={1.064} fill="currentColor" />
    <path
      d="M5.68 16.057c.14-2.666.865-5.045 2.54-6.825C10.138 7.194 13.237 6 16.003 6s5.864 1.194 7.782 3.232c1.676 1.78 2.4 4.159 2.54 6.825H5.68Z"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default SvgIcoFood;
